import actionTypes from '../constants/action-types';

const clearHistory = () => ({
  type: actionTypes.CLEAR_HISTORY,
});

export default clearHistory;
